import { AmbassadorThird } from '../../../enums';
import { AmbassadorToggleMolecule } from '../../molecules/';
import { useAmbassadorThird } from '../../../styles/organisms/ambassador-third.styles';

export const AmbassadorLookingInfluenceOrganism = () => {
  const classes = useAmbassadorThird();
  return (
    <div className="w-full relative  mt-0 lg:mt-20 pb-10">
      <div className="block flex flex-col mt-10 w-10/12  mx-auto">
        <h2 className="text-large leading-10 block text-left w-80">
          <span className="underline inline-block">We’re looking for</span>
          {AmbassadorThird.THIRD_TITLE}
        </h2>
      </div>
      <div
        className={`${classes.bgLensHand} w-3/4  absolute h-full top-0 wrap -left-2 mt-40 bottom-0`}
      ></div>
      <div className="block flex flex-col items-end w-3/4 md:w-1/2 mx-auto mt-48">
        <AmbassadorToggleMolecule
          title={AmbassadorThird.DEVELOP_TITLE}
          content={AmbassadorThird.DEVELOP_DESC}
          display="mb-32"
          boxStyling="w-48 lg:w-full -mt-4 lg:mt-0"
        />
        <AmbassadorToggleMolecule
          title={AmbassadorThird.PROMOTE_TITLE}
          content={AmbassadorThird.PROMOTE_DESC}
          display="pr-12 lg:pr-10 mb-32 lg:mb-28"
          boxStyling="w-64 lg:w-full -mt-4 lg:mt-0"
        />
        <AmbassadorToggleMolecule
          title={AmbassadorThird.EDUCATE_TITLE}
          content={AmbassadorThird.EDUCATE_DESC}
          display="pr-32 lg:pr-20 mb-28"
          boxStyling="w-80 "
        />
      </div>
    </div>
  );
};
